import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeIT from '@angular/common/locales/it';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiInterceptor } from './services/api.service';


// PAGES
import { HomeComponent } from './pages/home/home.component';
import { InfoComponent } from './pages/info/info.component';
import { StagioneComponent } from './pages/stagione/stagione.component';
import { MakingTecaComponent } from './pages/making-teca/making-teca.component';
import { AbbecedarioComponent } from './pages/abbecedario/abbecedario.component';
import { NewsComponent } from './pages/news/news.component';
import { MakingTecaPostComponent } from './pages/making-teca-post/making-teca-post.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { CondizioniVenditaComponent } from './pages/condizioni-vendita/condizioni-vendita.component';
import { SpettacoloComponent } from './pages/spettacolo/spettacolo.component';
import { AmministrazioneTrasparenteComponent } from './pages/amministrazione-trasparente/amministrazione-trasparente.component';
import { NotiziaComponent } from './pages/notizia/notizia.component';
import { ContattiComponent } from './pages/contatti/contatti.component';
import { BackofficeComponent } from './pages/backoffice/backoffice.component';
import { LoginComponent } from './pages/backoffice/login/login.component';
import { HomeBackofficeComponent } from './pages/backoffice/home-backoffice/home-backoffice.component';
import { UtentiBackofficeComponent } from './pages/backoffice/utenti-backoffice/utenti-backoffice.component';
import { AggiungiUtenteBackofficeComponent } from './pages/backoffice/utenti-backoffice/aggiungi-utente-backoffice/aggiungi-utente-backoffice.component';
import { ModificaUtenteBackofficeComponent } from './pages/backoffice/utenti-backoffice/modifica-utente-backoffice/modifica-utente-backoffice.component';
import { MakingTecaBackofficeComponent } from './pages/backoffice/making-teca-backoffice/making-teca-backoffice.component';
import { AggiungiMakingTecaBackofficeComponent } from './pages/backoffice/making-teca-backoffice/aggiungi-making-teca-backoffice/aggiungi-making-teca-backoffice.component';
import { ModificaMakingTecaBackofficeComponent } from './pages/backoffice/making-teca-backoffice/modifica-making-teca-backoffice/modifica-making-teca-backoffice.component';
import { AmministrazioneTrasparenteBackofficeComponent } from './pages/backoffice/amministrazione-trasparente-backoffice/amministrazione-trasparente-backoffice.component';
import { AggiungiAmministrazioneTrasparenteBackofficeComponent } from './pages/backoffice/amministrazione-trasparente-backoffice/aggiungi-amministrazione-trasparente-backoffice/aggiungi-amministrazione-trasparente-backoffice.component';
import { ModificaAmministrazioneTrasparenteBackofficeComponent } from './pages/backoffice/amministrazione-trasparente-backoffice/modifica-amministrazione-trasparente-backoffice/modifica-amministrazione-trasparente-backoffice.component';
import { NewsBackofficeComponent } from './pages/backoffice/news-backoffice/news-backoffice.component';
import { AggiungiNewsBackofficeComponent } from './pages/backoffice/news-backoffice/aggiungi-news-backoffice/aggiungi-news-backoffice.component';
import { ModificaNewsBackofficeComponent } from './pages/backoffice/news-backoffice/modifica-news-backoffice/modifica-news-backoffice.component';
import { ContattiBackofficeComponent } from './pages/backoffice/contatti-backoffice/contatti-backoffice.component';
import { AggiungiContattoBackofficeComponent } from './pages/backoffice/contatti-backoffice/aggiungi-contatto-backoffice/aggiungi-contatto-backoffice.component';
import { ModificaContattoBackofficeComponent } from './pages/backoffice/contatti-backoffice/modifica-contatto-backoffice/modifica-contatto-backoffice.component';
import { AbbecedarioBackofficeComponent } from './pages/backoffice/abbecedario-backoffice/abbecedario-backoffice.component';
import { AggiungiAbbecedarioBackofficeComponent } from './pages/backoffice/abbecedario-backoffice/aggiungi-abbecedario-backoffice/aggiungi-abbecedario-backoffice.component';
import { ModificaAbbecedarioBackofficeComponent } from './pages/backoffice/abbecedario-backoffice/modifica-abbecedario-backoffice/modifica-abbecedario-backoffice.component';
import { SpettacoliBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/spettacoli-backoffice.component';
import { AggiungiSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/aggiungi-spettacolo-backoffice/aggiungi-spettacolo-backoffice.component';
import { ModificaSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/modifica-spettacolo-backoffice/modifica-spettacolo-backoffice.component';
import { NewsletterBackofficeComponent } from './pages/backoffice/newsletter-backoffice/newsletter-backoffice.component';
import { AggiungiNewsletterBackofficeComponent } from './pages/backoffice/newsletter-backoffice/aggiungi-newsletter-backoffice/aggiungi-newsletter-backoffice.component';
import { ModificaNewsletterBackofficeComponent } from './pages/backoffice/newsletter-backoffice/modifica-newsletter-backoffice/modifica-newsletter-backoffice.component';
import { ConfigurazioniBackofficeComponent } from './pages/backoffice/configurazioni-backoffice/configurazioni-backoffice.component';
import { AggiungiConfigurazioneBackofficeComponent } from './pages/backoffice/configurazioni-backoffice/aggiungi-configurazione-backoffice/aggiungi-configurazione-backoffice.component';
import { ModificaConfigurazioneBackofficeComponent } from './pages/backoffice/configurazioni-backoffice/modifica-configurazione-backoffice/modifica-configurazione-backoffice.component';
import { VouchersBackofficeComponent } from './pages/backoffice/vouchers-backoffice/vouchers-backoffice.component';
import { ModificaVoucherBackofficeComponent } from './pages/backoffice/vouchers-backoffice/modifica-voucher-backoffice/modifica-voucher-backoffice.component';
import { AggiungiVoucherBackofficeComponent } from './pages/backoffice/vouchers-backoffice/aggiungi-voucher-backoffice/aggiungi-voucher-backoffice.component';
import { StagioneBackofficeComponent } from './pages/backoffice/stagione-backoffice/stagione-backoffice.component';
import { HomeEvidenzaBackofficeComponent } from './pages/backoffice/home-evidenza-backoffice/home-evidenza-backoffice.component';
import { CarnetComponent } from './pages/carnet/carnet.component';
import { CarnetBackofficeComponent } from './pages/backoffice/carnet-backoffice/carnet-backoffice.component';
import { AggiungiCarnetBackofficeComponent } from './pages/backoffice/carnet-backoffice/aggiungi-carnet-backoffice/aggiungi-carnet-backoffice.component';
import { ModificaCarnetBackofficeComponent } from './pages/backoffice/carnet-backoffice/modifica-carnet-backoffice/modifica-carnet-backoffice.component';
import { InfoBackofficeComponent } from './pages/backoffice/info-backoffice/info-backoffice.component';
import { AggiungiInfoBackofficeComponent } from './pages/backoffice/info-backoffice/aggiungi-info-backoffice/aggiungi-info-backoffice.component';
import { ModificaInfoBackofficeComponent } from './pages/backoffice/info-backoffice/modifica-info-backoffice/modifica-info-backoffice.component';
import { AccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/accrediti-backoffice.component';
import { ModificaAccreditoBackofficeComponent } from './pages/backoffice/accrediti-backoffice/modifica-accredito-backoffice/modifica-accredito-backoffice.component';
import { PersonaleAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/personale-accrediti-backoffice/personale-accrediti-backoffice.component';
import { AddPersonaleAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/personale-accrediti-backoffice/add-personale-accrediti-backoffice/add-personale-accrediti-backoffice.component';
import { EditPersonaleAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/personale-accrediti-backoffice/edit-personale-accrediti-backoffice/edit-personale-accrediti-backoffice.component';
import { SubappaltiAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/subappalti-accrediti-backoffice/subappalti-accrediti-backoffice.component';
import { AddSubappaltoAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/subappalti-accrediti-backoffice/add-subappalto-accrediti-backoffice/add-subappalto-accrediti-backoffice.component';
import { EditSubappaltoAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/subappalti-accrediti-backoffice/edit-subappalto-accrediti-backoffice/edit-subappalto-accrediti-backoffice.component';
import { MezziTrasportoAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/mezzi-trasporto-accrediti-backoffice/mezzi-trasporto-accrediti-backoffice.component';
import { AddMezzoTrasportoAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/mezzi-trasporto-accrediti-backoffice/add-mezzo-trasporto-accrediti-backoffice/add-mezzo-trasporto-accrediti-backoffice.component';
import { CastSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/cast-spettacolo-backoffice/cast-spettacolo-backoffice.component';
import { PrezziSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/prezzi-spettacolo-backoffice/prezzi-spettacolo-backoffice.component';
import { EditMezzoTrasportoAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/mezzi-trasporto-accrediti-backoffice/edit-mezzo-trasporto-accrediti-backoffice/edit-mezzo-trasporto-accrediti-backoffice.component';
import { UtentiAccreditoSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/utenti-accredito-spettacolo-backoffice/utenti-accredito-spettacolo-backoffice.component';
import { AccreditoSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/accredito-spettacolo-backoffice/accredito-spettacolo-backoffice.component';
import { PersonaleAccreditoSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/personale-accredito-spettacolo-backoffice/personale-accredito-spettacolo-backoffice.component';
import { LoadingBackofficeComponent } from './common/loading-backoffice/loading-backoffice.component';
import { DocumentiAccreditiBackofficeComponent } from './pages/backoffice/accrediti-backoffice/documenti-accrediti-backoffice/documenti-accrediti-backoffice.component';
import { ImmaginiSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/immagini-spettacolo-backoffice/immagini-spettacolo-backoffice.component';
import { CalendarioSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/calendario-spettacolo-backoffice/calendario-spettacolo-backoffice.component';
import { TimelineSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/timeline-spettacolo-backoffice/timeline-spettacolo-backoffice.component';
import { GalleriaSpettacoloBackofficeComponent } from './pages/backoffice/spettacoli-backoffice/galleria-spettacolo-backoffice/galleria-spettacolo-backoffice.component';
import { AccreditoBackofficeComponent } from './pages/backoffice/accrediti-backoffice/accredito-backoffice/accredito-backoffice.component';
// PAGES

// COMMON
import { FooterComponent } from './common/footer/footer.component';
import { SliderComponent } from './common/slider/slider.component';
import { NewsBoxComponent } from './common/news-box/news-box.component';
import { SpettacoloBoxComponent } from './common/spettacolo-box/spettacolo-box.component';
import { StrutturaComponent } from './common/struttura/struttura.component';
import { StrutturaBackofficeComponent } from './common/struttura-backoffice/struttura-backoffice.component';
import { ToastComponent } from './common/toast/toast.component';
import { BreadcrumbBackofficeComponent } from './common/breadcrumb-backoffice/breadcrumb-backoffice.component';
import { NavComponent } from './common/nav/nav.component';
import { BoxStagioneComponent } from './common/box-stagione/box-stagione.component';
import { ImageCropperComponent } from './common/image-cropper/image-cropper.component';
import { StagioneHomeComponent } from './common/stagione-home/stagione-home.component';
import { LoadingComponent } from './common/loading/loading.component';
import { ButtonSpettacoloComponent } from './common/button-spettacolo/button-spettacolo.component';
import { DateSpettacoloComponent } from './common/date-spettacolo/date-spettacolo.component';
import { VideoGalleriaSpettacoloComponent } from './common/video-galleria-spettacolo/video-galleria-spettacolo.component';
import { CookiesComponent } from './common/cookies/cookies.component';
import { FileUploadComponent } from './common/file-upload/file-upload.component';
import { FileLoadedComponent } from './common/file-loaded/file-loaded.component';
// COMMON

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';

// PRIMENG
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { PasswordModule } from 'primeng/password';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask'; 
import { CheckboxModule } from 'primeng/checkbox'; 
import { DialogModule } from 'primeng/dialog'; 
import { DividerModule } from 'primeng/divider'; 
import { ImageModule } from 'primeng/image';
import { TooltipModule } from 'primeng/tooltip';
import { StepsModule } from 'primeng/steps';
import { StepperModule } from 'primeng/stepper';
import { ScrollTopModule } from 'primeng/scrolltop';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextareaModule } from 'primeng/inputtextarea';
// PRIMENG

// SWIPER
import { register as registerSwiperElement } from 'swiper/element/bundle';
// SWIPER

// IMAGE CROPPER
import { ImageCropperModule } from 'ngx-image-cropper';
// IMAGE CROPPER

// PIPES
import { categoriaAmministrazioneTrasparentePipe, prezziSpettacoloPipe, ruoloCastSpettacoloPipe } from './shared/pipe';
import { FilePipe } from './shared/file.pipe';
import { ImagePipe } from './shared/image.pipe';
import { PdfPipe } from './shared/pdf.pipe';
import { TypePipe } from './shared/type.pipe';
import { AuthSrcDirective } from './shared/auth-src.directive';

// PIPES

registerSwiperElement()
registerLocaleData(localeIT, 'it');

@NgModule({
  declarations: [
    AppComponent,    
    NewsComponent,
    FooterComponent,
    HomeComponent,
    InfoComponent,
    StagioneComponent,
    MakingTecaComponent,
    MakingTecaPostComponent,
    SliderComponent,
    AbbecedarioComponent,
    NewsBoxComponent,
    SpettacoloBoxComponent,
    AmministrazioneTrasparenteComponent,
    categoriaAmministrazioneTrasparentePipe,
    prezziSpettacoloPipe,
    ruoloCastSpettacoloPipe,
    PrivacyComponent,
    SpettacoloComponent,
    BackofficeComponent,
    LoginComponent,
    StrutturaComponent,
    StrutturaBackofficeComponent,
    HomeBackofficeComponent,
    UtentiBackofficeComponent,
    ToastComponent,
    NotiziaComponent,
    AggiungiUtenteBackofficeComponent,
    ModificaUtenteBackofficeComponent,    
    MakingTecaBackofficeComponent,
    AggiungiMakingTecaBackofficeComponent,
    ModificaMakingTecaBackofficeComponent,
    AmministrazioneTrasparenteBackofficeComponent,
    AggiungiAmministrazioneTrasparenteBackofficeComponent,
    ModificaAmministrazioneTrasparenteBackofficeComponent,
    NewsBackofficeComponent,
    BreadcrumbBackofficeComponent,
    AggiungiNewsBackofficeComponent,
    ModificaNewsBackofficeComponent,
    ContattiBackofficeComponent,
    AggiungiContattoBackofficeComponent,
    ModificaContattoBackofficeComponent,
    AbbecedarioBackofficeComponent,
    AggiungiAbbecedarioBackofficeComponent,
    ModificaAbbecedarioBackofficeComponent,
    NavComponent,
    ContattiComponent,
    SpettacoliBackofficeComponent,
    AggiungiSpettacoloBackofficeComponent,    
    BoxStagioneComponent,
    ModificaSpettacoloBackofficeComponent,
    ImageCropperComponent,
    NewsletterBackofficeComponent,
    AggiungiNewsletterBackofficeComponent,
    ModificaNewsletterBackofficeComponent,
    ConfigurazioniBackofficeComponent,
    AggiungiConfigurazioneBackofficeComponent,
    ModificaConfigurazioneBackofficeComponent,
    StagioneHomeComponent,
    LoadingComponent,
    ButtonSpettacoloComponent,
    VideoGalleriaSpettacoloComponent,
    DateSpettacoloComponent,
    VouchersBackofficeComponent,
    ModificaVoucherBackofficeComponent,
    CookiesComponent,
    StagioneBackofficeComponent,
    HomeEvidenzaBackofficeComponent,
    AggiungiVoucherBackofficeComponent,
    CarnetComponent,
    CarnetBackofficeComponent,
    AggiungiCarnetBackofficeComponent,
    ModificaCarnetBackofficeComponent,
    InfoBackofficeComponent,
    AggiungiInfoBackofficeComponent,
    ModificaInfoBackofficeComponent,
    CondizioniVenditaComponent,    
    AccreditiBackofficeComponent,    
    ModificaAccreditoBackofficeComponent,    
    FileUploadComponent,
    PersonaleAccreditiBackofficeComponent,
    AddPersonaleAccreditiBackofficeComponent,
    EditPersonaleAccreditiBackofficeComponent,
    SubappaltiAccreditiBackofficeComponent,
    AddSubappaltoAccreditiBackofficeComponent,
    EditSubappaltoAccreditiBackofficeComponent,
    MezziTrasportoAccreditiBackofficeComponent,
    AddMezzoTrasportoAccreditiBackofficeComponent,
    CastSpettacoloBackofficeComponent,
    PrezziSpettacoloBackofficeComponent, 
    EditMezzoTrasportoAccreditiBackofficeComponent,
    UtentiAccreditoSpettacoloBackofficeComponent, 
    AccreditoSpettacoloBackofficeComponent, 
    PersonaleAccreditoSpettacoloBackofficeComponent, FilePipe, AuthSrcDirective,
    LoadingBackofficeComponent, 
    DocumentiAccreditiBackofficeComponent, 
    ImmaginiSpettacoloBackofficeComponent, 
    ImagePipe, TypePipe,
    CalendarioSpettacoloBackofficeComponent, 
    TimelineSpettacoloBackofficeComponent, 
    PdfPipe, GalleriaSpettacoloBackofficeComponent, 
    AccreditoBackofficeComponent, FileLoadedComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,    
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteModule,
    DropdownModule,
    InputTextModule,
    PaginatorModule,  
    InputGroupAddonModule,
    InputGroupModule,
    ButtonModule,
    SidebarModule,
    RippleModule,
    TableModule,
    PasswordModule,
    ToastModule,
    ConfirmPopupModule,
    BreadcrumbModule,
    CalendarModule,
    FileUploadModule,
    EditorModule,
    InputMaskModule,
    CheckboxModule,
    DialogModule,
    ImageModule,
    DividerModule,
    ImageCropperModule,
    TooltipModule,
    StepsModule,
    StepperModule,
    ScrollTopModule,
    MultiSelectModule,
    RadioButtonModule,
    InputNumberModule,
    InputTextareaModule,
  ],
  providers: [
    provideHttpClient(withFetch()),
    MessageService, ConfirmationService,
    { provide: DatePipe }, { provide: ImagePipe }, { provide: FilePipe },
    { provide: LOCALE_ID, useValue: "it" },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
